export class ParseError extends Error {
  constructor(
    message: string,
    public rawBody: string,
    public status: number
  ) {
    super(message);
    this.name = 'ParseError';
  }
}
